export default __webpack_public_path__ + "static/media/a011-example4.47a85b0d.png";